<template>
  <dialog-reset title="激活系统"
                :visible.sync="formVisible"
                :slotShow="true"
                width="35%"
                height="300px">
    <div class="avue-form--container">
      <el-form :model="formData"
               :rules="rules"
               ref="ruleForm"
               label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="单位名称："
                      prop="deptId">
          <el-input v-if="deptName"
                    v-model="formData.deptName"
                    disabled></el-input>
          <select-tree v-else
                       v-model="formData.deptId"
                       :options="minelist"
                       :formData="formData"
                       :disabled="disabled"
                       :config="{
                          soleValue: 'deptId',
                          value: 'id', // ID字段名
                          label: 'title', // 显示名称
                          children: 'children',
                        }"
                       style="width: 100%" />
        </el-form-item>

        <el-form-item label="激活码："
                      prop="data">
          <el-input v-model="formData.data"
                    type="textarea"
                    rows="4"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <span slot="dialog_footer">
      <el-button type="primary"
                 icon="el-icon-circle-plus-outline"
                 @click="submit">提 交</el-button>
    </span>
  </dialog-reset>
</template>

<script>
import { activate } from '@/api/user.js'
import { getDictionaries } from '@/basic-common/util/dictionaries.js'
export default {
  data() {
    return {
      formVisible: false,
      formData: {},
      minelist: [],
      rules: {
        deptId: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change'],
          },
        ],
        data: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change'],
          },
        ],
      },
    }
  },
  props: {
    deptName: {
      type: String,
      default: '',
    },
    deptId: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  async created() {
    if (this.deptName) {
      this.formData.deptName = this.deptName
      this.$set(this.formData, 'deptId', this.deptId)
    } else {
      this.minelist = await getDictionaries('/api/blade-system/dept/tree')
      this.$set(
        this.formData,
        'deptId',
        this.deptId || this.$store.state.user.userInfo.dept_id
      )
    }
  },
  methods: {
    handleShow() {
      this.formVisible = true
      process.nextTick(() => {
        this.getNoticeData()
      })
    },
    getNoticeData() {},
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          activate(this.formData)
            .then((res) => {
              this.$store.commit('REMINDER_DATA', null)
              this.$message({
                type: 'success',
                message: res.data.msg,
              })
            })
            .catch(() => {})
        } else {
          this.$message.error('错误, 请验证必填项并录入符合规则的数据')
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.avue-form--container {
  padding: 50px 30px 0 0;
}

::v-deep .el-dialog__wrapper {
  .el-dialog__headerbtn {
    top: 7px !important;
  }
}

::v-deep .avue-ueditor {
  margin-right: 20px;
}
</style>
